<template>
    <div class="certificateManage">
       <router-view></router-view>
    </div>
</template>


<script>
export default {
  name: "certificateManage",
  data() {
    return {};
  }
};
</script>

<style lang="stylus" scoped>
    
</style>
